export const FILTER_CHANGE = '[FILTER] FILTER_CHANGE';

export function changeFilter(data) {
    return {
        type: FILTER_CHANGE,
        data
    }
}